// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__2ZB_L","noHoverBg":"CellularCapability_noHoverBg__1-6-C"};